import { defineMessages } from 'react-intl';

export const accountlinkfaqPageDetails = defineMessages({
  learnMoreAboutProfileLinking: {
    id: 'accountlinkfaqPageDetails.learnMoreAboutProfileLinking',
    defaultMessage: 'Learn more about profile linking',
    description: 'Learn more about profile linking',
  },
});
